export default __webpack_public_path__ + "static/media/localTwo.ba1db976.svg";